module.exports = __webpack_public_path__ + "img/avator4.72ce0bc0.png";